import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = { open: { type: Boolean, default: false }, disabledMessage: String }

  connect() {
    this.element.dataset.dropdownMenuConnected = "true"
    this.onDocumentClick = this.onDocumentClick.bind(this)
    // Use capture so other handlers calling stopPropagation don't prevent closing
    document.addEventListener("click", this.onDocumentClick, true)
    this.sync()
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick, true)
  }

  stop(event) {
    event?.stopPropagation?.()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const nextOpen = !this.openValue
    if (nextOpen) this.closeOtherDropdowns()

    this.openValue = nextOpen
    this.sync()
  }

  toggleWithKeyboard(event) {
    const key = event?.key
    if (key !== "Enter" && key !== " ") return
    this.toggle(event)
  }

  close() {
    this.openValue = false
    this.sync()
  }

  disabledAction(event) {
    event.preventDefault()
    event.stopPropagation()

    const message = this.disabledMessageValue || "Action indisponible pour le moment."
    window.alert(message)
    this.close()
  }

  onDocumentClick(event) {
    if (!this.openValue) return
    if (this.element.contains(event.target)) return
    this.close()
  }

  closeOtherDropdowns() {
    // Close any other open dropdown menus on the page.
    document.querySelectorAll("[data-dropdown-menu-connected='true']").forEach(el => {
      if (el === this.element) return
      const controller = this.application?.getControllerForElementAndIdentifier(el, "dropdown-menu")
      controller?.close?.()
    })
  }

  sync() {
    if (!this.hasMenuTarget) return
    this.menuTarget.style.display = this.openValue ? "block" : "none"
    this.element.classList.toggle("dropdown-open", this.openValue)
  }
}

